import moment from 'moment'

function isHolidays(dateStart, dateEnd) {
  const year = moment(dateStart).year()

  const holidays = [
    {
      dateStart: `${year}-06-15`,
      dateEnd: `${year}-09-15`,
      name: 'Sezon letni'
    },
    {
      dateStart: `${year}-12-20`,
      dateEnd: `${year}-12-31`,
      name: 'Sezon zimowy'
    },
    {
      dateStart: `${year}-01-01`,
      dateEnd: `${year}-03-31`,
      name: 'Sezon zimowy'
    },
    {
      dateStart: `${year}-05-01`,
      dateEnd: `${year}-05-03`,
      name: 'Długi weekend majowy'
    },
    {
      dateStart: `${year}-08-15`,
      dateEnd: `${year}-08-15`,
      name: 'Święto 15 sierpnia'
    },
    {
      dateStart: `${year}-11-11`,
      dateEnd: `${year}-11-11`,
      name: 'Święto 11 listopada'
    }
  ]

  let current = holidays.filter(
    h =>
      moment(dateStart).isSameOrBefore(h.dateEnd) &&
      moment(dateEnd).isSameOrAfter(h.dateStart)
  )

  return current.length ? current[0].name : false
}

export { isHolidays }
